// extracted by mini-css-extract-plugin
module.exports = {"header_text":"index-module--header_text--2Id9e","description":"index-module--description--1NQv6","header_text_card":"index-module--header_text_card--2gn03"};